import React from 'react';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../../constants/routes';

// One gradient card holding three stakeholder panels, a dashed "thread" joining them, and the
// shared payoff below. Classes are prefixed — the design uses .panel / .stage / .flow, which would
// collide with the global utility stylesheets.
const PANELS = [
    {
        num: '01', title: 'Companies', role: 'Get deal-ready',
        points: [
            <>Investment- or exit-ready in <b>days, not months</b> — 200 AI agents auto-fill up to 60% of your pack</>,
            <>Self-certify <b>Bronze, Silver or Gold</b></>,
            <>Stay deal-ready for every follow-on round and exit</>,
            <>Gold unlocks <b>InvestorMatch</b> to 40+ investors</>,
        ],
        foot: 'Free to start',
    },
    {
        num: '02', title: 'Advisors', role: 'Prove your value',
        points: [
            <>Free account — <b>no licence, no revenue share</b></>,
            <>Every client starts at <b>60%, not zero</b></>,
            <>Billable work surfaced automatically across your book</>,
            <>Get discovered by companies and 40+ VCs via <b>AdvisorMatch</b></>,
        ],
        foot: 'Free for advisors',
    },
    {
        num: '03', title: 'Investors & Purchasers', role: 'Get matched deals',
        points: [
            <>Free application triage in <b>3–4 minutes</b></>,
            <><b>FREE</b> AI-driven deal management platform</>,
            <>Automated diligence — corporate, legal, financial, tech — or connect your own tools</>,
            <><b>Pre-qualified, pre-diligenced</b> dealflow shared across 40+ investors</>,
        ],
        foot: 'Free for investors',
    },
];

// Dashed rule with a marker centred under each panel.
const Thread = () => (
    <div className="lp-wwd-thread" aria-hidden="true">
        <svg viewBox="0 0 1160 32" preserveAspectRatio="none">
            <line x1="0" y1="16" x2="1160" y2="16" stroke="rgba(255,255,255,0.35)" strokeWidth="1.5" strokeDasharray="2 6" strokeLinecap="round" />
            <circle cx="193" cy="16" r="4" fill="#F5A623" />
            <circle cx="580" cy="16" r="4" fill="#F5A623" />
            <circle cx="967" cy="16" r="4" fill="#F5A623" />
        </svg>
    </div>
);

const HomeWhatWeDo = () => (
    <section className="lp-wwd">
        <div className="lp-wwd-inner">
            <div className="lp-wwd-head">
                <span className="lp-wwd-eyebrow" data-lp-reveal><span className="dot" />What we do</span>
                <h2 data-lp-reveal data-lp-delay="60">One platform. Value for every side of the deal.</h2>
                <p data-lp-reveal data-lp-delay="120">Companies get investment/exit ready, advisors add value more quickly, investors get inbound qualified dealflow.</p>
            </div>

            <div className="lp-wwd-flow" data-lp-reveal data-lp-delay="160">
                <div className="lp-wwd-panels">
                    {PANELS.map(p => (
                        <div className="lp-wwd-panel" key={p.num}>
                            <div className="lp-wwd-stage">
                                <span className="lp-wwd-stage-num">{p.num}</span>
                                <div>
                                    <h3>{p.title}</h3>
                                    <span className="lp-wwd-role">{p.role}</span>
                                </div>
                            </div>
                            <ul>
                                {p.points.map((pt, i) => (
                                    <li key={i}><span className="lp-wwd-pdot" /><span>{pt}</span></li>
                                ))}
                            </ul>
                            <span className="lp-wwd-panel-foot">{p.foot}</span>
                        </div>
                    ))}
                </div>

                <Thread />

                <div className="lp-wwd-payoff">
                    <p className="lp-wwd-payoff-text">
                        <span className="bolt">⚡</span>Our differentiator? A single integrated platform for all stakeholders over the company lifecycle — delivering quicker deals, less cost, expedited follow-on rounds, and <span className="hl">higher valuations</span> for everyone.
                    </p>
                    <Link className="lp-wwd-btn" to={ROUTES.REGISTER}>Get started free</Link>
                </div>
            </div>
        </div>
    </section>
);

export default HomeWhatWeDo;
